import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  class: "modal-content",
  style: {"overflow":"visible"}
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "modal-footer"
}

import {onMounted, ref, watch} from "vue";
import {Modal} from "bootstrap";


export default /*@__PURE__*/_defineComponent({
  __name: 'InformationModal',
  props: /*@__PURE__*/_mergeModels({
    showModal: { type: Boolean, default: false },
    title: { default: "" },
    body: {},
    showFooter: { type: Boolean },
    className: {},
    width: { default: "750px" }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["dismiss", "submit"], ["update:modelValue"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const model = _useModel(__props, "modelValue");
const props = __props;
let modalElement = ref<HTMLElement>();
let modelObject: Modal;

const state = ref(false);

onMounted(() => {
    modelObject = new Modal(modalElement.value);

    modalElement.value.addEventListener("hidden.bs.modal", (event) => {
        model.value = false;
        state.value = false;
        emit("dismiss");
    });
});

const emit = __emit;

function handleDismiss() {
    emit("dismiss");
}

function handleSubmit() {
    emit("submit");
}

function _show() {
    state.value = true;
    modelObject.show();
}

function _hide() {
    state.value = false;
    modelObject.hide();
    model.value = false;
    emit("dismiss");
}

watch(
    () => props.showModal,
    (showModal, prevShowModal) => {
        state.value = showModal;
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

watch(
    () => model.value,
    (showModal, prevShowModal) => {
        state.value = showModal as boolean;
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

__expose({show: _show});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade", [props.className]]),
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "false",
    tabindex: "-1",
    "aria-label": props.title,
    ref_key: "modalElement",
    ref: modalElement
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
      style: _normalizeStyle(`max-width: ${props.width}`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(props.title), 1),
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _renderSlot(_ctx.$slots, "body", {
              onDismiss: handleDismiss,
              onSubmit: handleSubmit
            }, () => [
              _createTextVNode(_toDisplayString(props.body), 1)
            ]),
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        (props.showFooter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "footer", {
                onDismiss: handleDismiss,
                onSubmit: handleSubmit
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ], 10, _hoisted_1))
}
}

})